@file:OptIn(InternalResourceApi::class)

package loco

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/loco/"

@delegate:ResourceContentHash(1_266_235_010)
public val Res.string.ABOUT_PRODUCT_SCREEN_TITLE_FORMAT: StringResource by lazy {
      StringResource("string:ABOUT_PRODUCT_SCREEN_TITLE_FORMAT", "ABOUT_PRODUCT_SCREEN_TITLE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 57),
      ))
    }

@delegate:ResourceContentHash(-108_602_308)
public val Res.string.BARCODE_SCANNER_INSTRUCTION: StringResource by lazy {
      StringResource("string:BARCODE_SCANNER_INSTRUCTION", "BARCODE_SCANNER_INSTRUCTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 68, 155),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 68, 175),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 76, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68, 135),
      ))
    }

@delegate:ResourceContentHash(-1_769_999_741)
public val Res.string.BARCODE_SCANNER_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:BARCODE_SCANNER_SCREEN_TITLE", "BARCODE_SCANNER_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 224, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 244, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 236, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204, 60),
      ))
    }

@delegate:ResourceContentHash(191_637_719)
public val Res.string.BLAND_TODAY_GREETING_DEFAULT: StringResource by lazy {
      StringResource("string:BLAND_TODAY_GREETING_DEFAULT", "BLAND_TODAY_GREETING_DEFAULT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 281, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 317, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 313, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 265, 40),
      ))
    }

@delegate:ResourceContentHash(-323_399_519)
public val Res.string.BLAND_TODAY_GREETING_USERNAME_FORMAT: StringResource by lazy {
      StringResource("string:BLAND_TODAY_GREETING_USERNAME_FORMAT", "BLAND_TODAY_GREETING_USERNAME_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 326, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 366, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 362, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306, 56),
      ))
    }

@delegate:ResourceContentHash(-1_267_054_222)
public val Res.string.BLAND_TODAY_MAIN_CONTROL_SECTION: StringResource by lazy {
      StringResource("string:BLAND_TODAY_MAIN_CONTROL_SECTION", "BLAND_TODAY_MAIN_CONTROL_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 387, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 427, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 427, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 363, 56),
      ))
    }

@delegate:ResourceContentHash(1_920_269_140)
public val Res.string.CALI_GREETINGS_1: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_1", "CALI_GREETINGS_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 576, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 612, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 644, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 544, 52),
      ))
    }

@delegate:ResourceContentHash(1_256_427_297)
public val Res.string.CALI_GREETINGS_10: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_10", "CALI_GREETINGS_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 448, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 492, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 496, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 420, 61),
      ))
    }

@delegate:ResourceContentHash(1_794_103_116)
public val Res.string.CALI_GREETINGS_11: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_11", "CALI_GREETINGS_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 510, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 546, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 566, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 482, 61),
      ))
    }

@delegate:ResourceContentHash(-16_631_095)
public val Res.string.CALI_GREETINGS_2: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_2", "CALI_GREETINGS_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 641, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 657, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 717, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 597, 48),
      ))
    }

@delegate:ResourceContentHash(1_831_021_171)
public val Res.string.CALI_GREETINGS_3: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_3", "CALI_GREETINGS_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 702, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 718, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 778, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 646, 60),
      ))
    }

@delegate:ResourceContentHash(319_348_515)
public val Res.string.CALI_GREETINGS_4: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_4", "CALI_GREETINGS_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 763, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 775, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 835, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 707, 52),
      ))
    }

@delegate:ResourceContentHash(-476_697_002)
public val Res.string.CALI_GREETINGS_5: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_5", "CALI_GREETINGS_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 820, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 836, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 904, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 760, 48),
      ))
    }

@delegate:ResourceContentHash(1_765_574_354)
public val Res.string.CALI_GREETINGS_6: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_6", "CALI_GREETINGS_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 881, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 897, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 969, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 809, 64),
      ))
    }

@delegate:ResourceContentHash(1_478_006_584)
public val Res.string.CALI_GREETINGS_7: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_7", "CALI_GREETINGS_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 942, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 966, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1030, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 874, 60),
      ))
    }

@delegate:ResourceContentHash(1_879_670_818)
public val Res.string.CALI_GREETINGS_8: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_8", "CALI_GREETINGS_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 995, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1035, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1103, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 935, 64),
      ))
    }

@delegate:ResourceContentHash(-1_675_071_563)
public val Res.string.CALI_GREETINGS_9: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_9", "CALI_GREETINGS_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1056, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1100, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1172, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1000, 60),
      ))
    }

@delegate:ResourceContentHash(-323_399_519)
public val Res.string.CALI_GREETINGS_USERNAME_FORMAT: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_USERNAME_FORMAT", "CALI_GREETINGS_USERNAME_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1125, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1177, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1253, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1061, 50),
      ))
    }

@delegate:ResourceContentHash(-958_777_856)
public val Res.string.CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_LABEL: StringResource by lazy {
      StringResource("string:CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_LABEL", "CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1180, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1232, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1312, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1112, 61),
      ))
    }

@delegate:ResourceContentHash(-217_918_464)
public val Res.string.CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_TEXT: StringResource by lazy {
      StringResource("string:CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_TEXT", "CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_TEXT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1242, 172),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1294, 172),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1374, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1174, 148),
      ))
    }

@delegate:ResourceContentHash(1_085_059_715)
public val Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_HEADER: StringResource by lazy {
      StringResource("string:CALI_TODAY_OVERALL_DAILY_PROGRESS_HEADER", "CALI_TODAY_OVERALL_DAILY_PROGRESS_HEADER", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1415, 84),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1467, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1539, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1323, 76),
      ))
    }

@delegate:ResourceContentHash(1_446_439_812)
public val Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_LABEL: StringResource by lazy {
      StringResource("string:CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_LABEL", "CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1500, 84),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1540, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1620, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1400, 88),
      ))
    }

@delegate:ResourceContentHash(674_956_557)
public val Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_TEXT: StringResource by lazy {
      StringResource("string:CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_TEXT", "CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_TEXT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1585, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1625, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1709, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1489, 123),
      ))
    }

@delegate:ResourceContentHash(452_435_193)
public val Res.string.CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_LABEL: StringResource by lazy {
      StringResource("string:CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_LABEL", "CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1713, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1745, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1849, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1613, 66),
      ))
    }

@delegate:ResourceContentHash(361_169_617)
public val Res.string.CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_TEXT: StringResource by lazy {
      StringResource("string:CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_TEXT", "CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_TEXT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1784, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1816, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1904, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1680, 113),
      ))
    }

@delegate:ResourceContentHash(228_320_424)
public val Res.string.CONTENT_MEAL_PLAN_PERSONAL_LABEL: StringResource by lazy {
      StringResource("string:CONTENT_MEAL_PLAN_PERSONAL_LABEL", "CONTENT_MEAL_PLAN_PERSONAL_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1914, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1942, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2014, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1794, 72),
      ))
    }

@delegate:ResourceContentHash(-1_244_903_003)
public val Res.string.CONTENT_SHOPPING_LIST_BUTTON: StringResource by lazy {
      StringResource("string:CONTENT_SHOPPING_LIST_BUTTON", "CONTENT_SHOPPING_LIST_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1995, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2019, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2095, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1867, 56),
      ))
    }

@delegate:ResourceContentHash(631_861_769)
public val Res.string.DAILY_TASKS_COMPLETED_TASKS_SECTION: StringResource by lazy {
      StringResource("string:DAILY_TASKS_COMPLETED_TASKS_SECTION", "DAILY_TASKS_COMPLETED_TASKS_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2052, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2080, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2156, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1924, 51),
      ))
    }

@delegate:ResourceContentHash(-3_206_474)
public val Res.string.DAILY_TASKS_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:DAILY_TASKS_SCREEN_TITLE", "DAILY_TASKS_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2108, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2132, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2212, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1976, 60),
      ))
    }

@delegate:ResourceContentHash(-988_093_559)
public val Res.string.DAILY_TASKS_TO_DO_TASKS_SECTION: StringResource by lazy {
      StringResource("string:DAILY_TASKS_TO_DO_TASKS_SECTION", "DAILY_TASKS_TO_DO_TASKS_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2173, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2193, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2285, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2037, 51),
      ))
    }

@delegate:ResourceContentHash(941_517_973)
public val Res.string.ERROR_INVALID_CREDENTIALS: StringResource by lazy {
      StringResource("string:ERROR_INVALID_CREDENTIALS", "ERROR_INVALID_CREDENTIALS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2233, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2245, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2349, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2089, 73),
      ))
    }

@delegate:ResourceContentHash(1_267_630_604)
public val Res.string.FOOD_HISTORY_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:FOOD_HISTORY_SCREEN_TITLE", "FOOD_HISTORY_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2319, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2335, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2439, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2163, 61),
      ))
    }

@delegate:ResourceContentHash(109_442_373)
public val Res.string.GENERAL_AGE_EIGHTIES: StringResource by lazy {
      StringResource("string:GENERAL_AGE_EIGHTIES", "GENERAL_AGE_EIGHTIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2381, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2401, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2505, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2225, 40),
      ))
    }

@delegate:ResourceContentHash(-504_407_849)
public val Res.string.GENERAL_AGE_FIFTIES: StringResource by lazy {
      StringResource("string:GENERAL_AGE_FIFTIES", "GENERAL_AGE_FIFTIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2426, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2450, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2558, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2266, 39),
      ))
    }

@delegate:ResourceContentHash(-1_138_141_996)
public val Res.string.GENERAL_AGE_FORTIES: StringResource by lazy {
      StringResource("string:GENERAL_AGE_FORTIES", "GENERAL_AGE_FORTIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2470, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2494, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2606, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2306, 39),
      ))
    }

@delegate:ResourceContentHash(-2_009_117_816)
public val Res.string.GENERAL_AGE_NINETIES: StringResource by lazy {
      StringResource("string:GENERAL_AGE_NINETIES", "GENERAL_AGE_NINETIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2510, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2538, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2654, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2346, 40),
      ))
    }

@delegate:ResourceContentHash(-668_234_420)
public val Res.string.GENERAL_AGE_SEVENTIES: StringResource by lazy {
      StringResource("string:GENERAL_AGE_SEVENTIES", "GENERAL_AGE_SEVENTIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2551, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2587, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2707, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2387, 41),
      ))
    }

@delegate:ResourceContentHash(-1_061_974_203)
public val Res.string.GENERAL_AGE_SIXTIES: StringResource by lazy {
      StringResource("string:GENERAL_AGE_SIXTIES", "GENERAL_AGE_SIXTIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2593, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2637, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2757, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2429, 39),
      ))
    }

@delegate:ResourceContentHash(-655_285_016)
public val Res.string.GENERAL_AGE_THIRTIES: StringResource by lazy {
      StringResource("string:GENERAL_AGE_THIRTIES", "GENERAL_AGE_THIRTIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2633, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2685, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2801, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2469, 40),
      ))
    }

@delegate:ResourceContentHash(-553_459_686)
public val Res.string.GENERAL_AGE_TWENTIES: StringResource by lazy {
      StringResource("string:GENERAL_AGE_TWENTIES", "GENERAL_AGE_TWENTIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2678, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2734, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2846, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2510, 40),
      ))
    }

@delegate:ResourceContentHash(2_068_613_022)
public val Res.string.GENERAL_AGE_YOUR_AGE: StringResource by lazy {
      StringResource("string:GENERAL_AGE_YOUR_AGE", "GENERAL_AGE_YOUR_AGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2719, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2783, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2891, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2551, 40),
      ))
    }

@delegate:ResourceContentHash(227_158_144)
public val Res.string.GENERAL_BMI: StringResource by lazy {
      StringResource("string:GENERAL_BMI", "GENERAL_BMI", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2764, 23),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2824, 23),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2936, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2592, 23),
      ))
    }

@delegate:ResourceContentHash(1_565_800_832)
public val Res.string.GENERAL_CALORIES: StringResource by lazy {
      StringResource("string:GENERAL_CALORIES", "GENERAL_CALORIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2832, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2892, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3004, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2660, 28),
      ))
    }

@delegate:ResourceContentHash(-1_713_889_066)
public val Res.string.GENERAL_CALORIES_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_CALORIES_FORMAT", "GENERAL_CALORIES_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2788, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2848, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2960, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2616, 43),
      ))
    }

@delegate:ResourceContentHash(-1_684_385_530)
public val Res.string.GENERAL_CANCEL: StringResource by lazy {
      StringResource("string:GENERAL_CANCEL", "GENERAL_CANCEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2861, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2921, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3033, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2689, 30),
      ))
    }

@delegate:ResourceContentHash(1_581_631_286)
public val Res.string.GENERAL_CARBO: StringResource by lazy {
      StringResource("string:GENERAL_CARBO", "GENERAL_CARBO", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2896, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2956, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3068, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2720, 29),
      ))
    }

@delegate:ResourceContentHash(1_542_905_480)
public val Res.string.GENERAL_CM_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_CM_LABEL", "GENERAL_CM_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2938, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2998, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3102, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2750, 28),
      ))
    }

@delegate:ResourceContentHash(2_005_053_496)
public val Res.string.GENERAL_CONTINUE: StringResource by lazy {
      StringResource("string:GENERAL_CONTINUE", "GENERAL_CONTINUE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2967, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3027, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3131, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2779, 36),
      ))
    }

@delegate:ResourceContentHash(-1_702_893_161)
public val Res.string.GENERAL_DETAILS: StringResource by lazy {
      StringResource("string:GENERAL_DETAILS", "GENERAL_DETAILS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3000, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3064, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3168, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2816, 35),
      ))
    }

@delegate:ResourceContentHash(631_861_769)
public val Res.string.GENERAL_DONE: StringResource by lazy {
      StringResource("string:GENERAL_DONE", "GENERAL_DONE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3036, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3100, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3204, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2852, 28),
      ))
    }

@delegate:ResourceContentHash(2_115_557_577)
public val Res.string.GENERAL_ERROR_MAX_VALUE: StringResource by lazy {
      StringResource("string:GENERAL_ERROR_MAX_VALUE", "GENERAL_ERROR_MAX_VALUE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3069, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3129, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3237, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2881, 71),
      ))
    }

@delegate:ResourceContentHash(1_043_860_907)
public val Res.string.GENERAL_ERROR_MIN_VALUE: StringResource by lazy {
      StringResource("string:GENERAL_ERROR_MIN_VALUE", "GENERAL_ERROR_MIN_VALUE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3153, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3205, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3325, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2953, 71),
      ))
    }

@delegate:ResourceContentHash(551_794_917)
public val Res.string.GENERAL_FAT: StringResource by lazy {
      StringResource("string:GENERAL_FAT", "GENERAL_FAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3233, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3281, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3413, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3025, 23),
      ))
    }

@delegate:ResourceContentHash(-703_110_147)
public val Res.string.GENERAL_FIBRE: StringResource by lazy {
      StringResource("string:GENERAL_FIBRE", "GENERAL_FIBRE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3261, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3309, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3445, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3049, 29),
      ))
    }

@delegate:ResourceContentHash(-28_478_200)
public val Res.string.GENERAL_FT_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_FT_LABEL", "GENERAL_FT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3291, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3339, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3475, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3079, 28),
      ))
    }

@delegate:ResourceContentHash(-28_239_872)
public val Res.string.GENERAL_FT_UNIT: StringResource by lazy {
      StringResource("string:GENERAL_FT_UNIT", "GENERAL_FT_UNIT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3320, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3368, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3504, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3108, 27),
      ))
    }

@delegate:ResourceContentHash(-1_201_071_063)
public val Res.string.GENERAL_GENDER_MEN: StringResource by lazy {
      StringResource("string:GENERAL_GENDER_MEN", "GENERAL_GENDER_MEN", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3348, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3396, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3532, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3136, 30),
      ))
    }

@delegate:ResourceContentHash(226_940_167)
public val Res.string.GENERAL_GENDER_WOMEN: StringResource by lazy {
      StringResource("string:GENERAL_GENDER_WOMEN", "GENERAL_GENDER_WOMEN", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3387, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3435, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3567, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3167, 36),
      ))
    }

@delegate:ResourceContentHash(-202_114_411)
public val Res.string.GENERAL_GOOD_AFTERNOON: StringResource by lazy {
      StringResource("string:GENERAL_GOOD_AFTERNOON", "GENERAL_GOOD_AFTERNOON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3428, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3476, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3604, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3204, 50),
      ))
    }

@delegate:ResourceContentHash(1_310_509_917)
public val Res.string.GENERAL_GOOD_EVENING: StringResource by lazy {
      StringResource("string:GENERAL_GOOD_EVENING", "GENERAL_GOOD_EVENING", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3471, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3527, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3655, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3255, 44),
      ))
    }

@delegate:ResourceContentHash(-178_533_276)
public val Res.string.GENERAL_GOOD_MORNING: StringResource by lazy {
      StringResource("string:GENERAL_GOOD_MORNING", "GENERAL_GOOD_MORNING", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3516, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3576, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3696, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3300, 44),
      ))
    }

@delegate:ResourceContentHash(1_149_585_924)
public val Res.string.GENERAL_GOOD_NIGHT: StringResource by lazy {
      StringResource("string:GENERAL_GOOD_NIGHT", "GENERAL_GOOD_NIGHT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3561, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3621, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3737, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3345, 42),
      ))
    }

@delegate:ResourceContentHash(492_931_926)
public val Res.string.GENERAL_IN_UNIT: StringResource by lazy {
      StringResource("string:GENERAL_IN_UNIT", "GENERAL_IN_UNIT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3604, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3668, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3780, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3388, 27),
      ))
    }

@delegate:ResourceContentHash(338_150_798)
public val Res.string.GENERAL_KG_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_KG_LABEL", "GENERAL_KG_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3632, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3700, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3808, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3416, 28),
      ))
    }

@delegate:ResourceContentHash(1_851_676_942)
public val Res.string.GENERAL_LB_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_LB_LABEL", "GENERAL_LB_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3661, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3729, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3837, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3445, 28),
      ))
    }

@delegate:ResourceContentHash(1_267_411_435)
public val Res.string.GENERAL_LITRES: StringResource by lazy {
      StringResource("string:GENERAL_LITRES", "GENERAL_LITRES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3690, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3758, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3866, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3474, 30),
      ))
    }

@delegate:ResourceContentHash(1_988_667_772)
public val Res.string.GENERAL_NOW: StringResource by lazy {
      StringResource("string:GENERAL_NOW", "GENERAL_NOW", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3721, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3789, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3897, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3505, 23),
      ))
    }

@delegate:ResourceContentHash(-1_052_833_166)
public val Res.string.GENERAL_OK: StringResource by lazy {
      StringResource("string:GENERAL_OK", "GENERAL_OK", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3749, 22),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3817, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3933, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3529, 22),
      ))
    }

@delegate:ResourceContentHash(1_826_153_148)
public val Res.string.GENERAL_OPEN: StringResource by lazy {
      StringResource("string:GENERAL_OPEN", "GENERAL_OPEN", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3772, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3852, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3964, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3552, 28),
      ))
    }

@delegate:ResourceContentHash(1_296_689_088)
public val Res.string.GENERAL_OZ: StringResource by lazy {
      StringResource("string:GENERAL_OZ", "GENERAL_OZ", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3805, 22),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3881, 22),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3993, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3581, 22),
      ))
    }

@delegate:ResourceContentHash(694_608)
public val Res.string.GENERAL_PROTEIN: StringResource by lazy {
      StringResource("string:GENERAL_PROTEIN", "GENERAL_PROTEIN", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3828, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3904, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4016, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3604, 35),
      ))
    }

@delegate:ResourceContentHash(-1_372_763_885)
public val Res.string.GENERAL_RELATIVE_DATE_DAYS_AGO_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_RELATIVE_DATE_DAYS_AGO_FORMAT", "GENERAL_RELATIVE_DATE_DAYS_AGO_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3864, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3944, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4056, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3640, 61),
      ))
    }

@delegate:ResourceContentHash(-611_378_571)
public val Res.string.GENERAL_RELATIVE_DATE_TODAY: StringResource by lazy {
      StringResource("string:GENERAL_RELATIVE_DATE_TODAY", "GENERAL_RELATIVE_DATE_TODAY", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3926, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4010, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4126, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3702, 43),
      ))
    }

@delegate:ResourceContentHash(1_047_613_034)
public val Res.string.GENERAL_RELATIVE_DATE_YESTERDAY: StringResource by lazy {
      StringResource("string:GENERAL_RELATIVE_DATE_YESTERDAY", "GENERAL_RELATIVE_DATE_YESTERDAY", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3970, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4050, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4178, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3746, 51),
      ))
    }

@delegate:ResourceContentHash(-557_081_932)
public val Res.string.GENERAL_SAVE: StringResource by lazy {
      StringResource("string:GENERAL_SAVE", "GENERAL_SAVE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4022, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4098, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4226, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3798, 28),
      ))
    }

@delegate:ResourceContentHash(-398_839_959)
public val Res.string.GENERAL_STEPS: StringResource by lazy {
      StringResource("string:GENERAL_STEPS", "GENERAL_STEPS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4055, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4131, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4263, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3827, 29),
      ))
    }

@delegate:ResourceContentHash(-1_074_926_955)
public val Res.string.GENERAL_SYMPTOM_BLOATING: StringResource by lazy {
      StringResource("string:GENERAL_SYMPTOM_BLOATING", "GENERAL_SYMPTOM_BLOATING", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4089, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4161, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4289, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3857, 44),
      ))
    }

@delegate:ResourceContentHash(846_670_169)
public val Res.string.GENERAL_SYMPTOM_CONSTIPATION: StringResource by lazy {
      StringResource("string:GENERAL_SYMPTOM_CONSTIPATION", "GENERAL_SYMPTOM_CONSTIPATION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4138, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4210, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4342, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3902, 52),
      ))
    }

@delegate:ResourceContentHash(-1_882_501_719)
public val Res.string.GENERAL_SYMPTOM_EXCESS_GAS: StringResource by lazy {
      StringResource("string:GENERAL_SYMPTOM_EXCESS_GAS", "GENERAL_SYMPTOM_EXCESS_GAS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4191, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4267, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4395, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3955, 50),
      ))
    }

@delegate:ResourceContentHash(0)
public val Res.string.GENERAL_SYMPTOM_UNKNOWN: StringResource by lazy {
      StringResource("string:GENERAL_SYMPTOM_UNKNOWN", "GENERAL_SYMPTOM_UNKNOWN", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4258, 31),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4322, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4446, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4006, 31),
      ))
    }

@delegate:ResourceContentHash(1_804_211_963)
public val Res.string.GENERAL_TODAY: StringResource by lazy {
      StringResource("string:GENERAL_TODAY", "GENERAL_TODAY", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4290, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4354, 25),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4478, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4038, 29),
      ))
    }

@delegate:ResourceContentHash(-1_599_225_868)
public val Res.string.GENERAL_UNIT_CUP_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_CUP_LABEL", "GENERAL_UNIT_CUP_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4320, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4380, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4516, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4068, 38),
      ))
    }

@delegate:ResourceContentHash(881_250_752)
public val Res.string.GENERAL_UNIT_FL_OZ_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_FL_OZ_LABEL", "GENERAL_UNIT_FL_OZ_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4359, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4419, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4555, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4107, 44),
      ))
    }

@delegate:ResourceContentHash(218_924_864)
public val Res.string.GENERAL_UNIT_GRAM_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_GRAM_LABEL", "GENERAL_UNIT_GRAM_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4404, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4464, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4600, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4152, 35),
      ))
    }

@delegate:ResourceContentHash(-2_128_552_461)
public val Res.string.GENERAL_UNIT_MEAL_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_MEAL_LABEL", "GENERAL_UNIT_MEAL_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4440, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4500, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4636, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4188, 39),
      ))
    }

@delegate:ResourceContentHash(-1_925_640_512)
public val Res.string.GENERAL_UNIT_ML_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_ML_LABEL", "GENERAL_UNIT_ML_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4488, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4544, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4676, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4228, 33),
      ))
    }

@delegate:ResourceContentHash(1_298_412_992)
public val Res.string.GENERAL_UNIT_OZ_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_OZ_LABEL", "GENERAL_UNIT_OZ_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4522, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4578, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4710, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4262, 33),
      ))
    }

@delegate:ResourceContentHash(-449_354_507)
public val Res.string.GENERAL_UNIT_PIECE_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_PIECE_LABEL", "GENERAL_UNIT_PIECE_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4556, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4612, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4744, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4296, 44),
      ))
    }

@delegate:ResourceContentHash(1_773_853_336)
public val Res.string.GENERAL_UNIT_TBSP_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_TBSP_LABEL", "GENERAL_UNIT_TBSP_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4601, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4657, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4789, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4341, 39),
      ))
    }

@delegate:ResourceContentHash(-1_277_038_355)
public val Res.string.GENERAL_UNIT_TSP_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_TSP_LABEL", "GENERAL_UNIT_TSP_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4637, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4701, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4837, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4381, 34),
      ))
    }

@delegate:ResourceContentHash(146_994_466)
public val Res.string.GENERAL_WEIGHT_CUP_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_CUP_FORMAT", "GENERAL_WEIGHT_CUP_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4672, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4748, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4884, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4416, 45),
      ))
    }

@delegate:ResourceContentHash(-2_120_798_464)
public val Res.string.GENERAL_WEIGHT_FL_OZ_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_FL_OZ_FORMAT", "GENERAL_WEIGHT_FL_OZ_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4722, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4798, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4934, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4462, 51),
      ))
    }

@delegate:ResourceContentHash(1_031_063_104)
public val Res.string.GENERAL_WEIGHT_GRAM_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_GRAM_FORMAT", "GENERAL_WEIGHT_GRAM_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4774, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4850, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4986, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4514, 42),
      ))
    }

@delegate:ResourceContentHash(-56_044_352)
public val Res.string.GENERAL_WEIGHT_KG_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_KG_FORMAT", "GENERAL_WEIGHT_KG_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4817, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4893, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5029, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4557, 44),
      ))
    }

@delegate:ResourceContentHash(1_213_401_408)
public val Res.string.GENERAL_WEIGHT_LB_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_LB_FORMAT", "GENERAL_WEIGHT_LB_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4862, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4938, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5074, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4602, 44),
      ))
    }

@delegate:ResourceContentHash(-80_249_178)
public val Res.string.GENERAL_WEIGHT_MEAL_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_MEAL_FORMAT", "GENERAL_WEIGHT_MEAL_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4907, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4983, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5119, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4647, 50),
      ))
    }

@delegate:ResourceContentHash(-1_882_028_608)
public val Res.string.GENERAL_WEIGHT_ML_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_ML_FORMAT", "GENERAL_WEIGHT_ML_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4966, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5034, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5170, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4698, 44),
      ))
    }

@delegate:ResourceContentHash(-1_226_223_168)
public val Res.string.GENERAL_WEIGHT_OZ_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_OZ_FORMAT", "GENERAL_WEIGHT_OZ_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5011, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5079, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5215, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4743, 44),
      ))
    }

@delegate:ResourceContentHash(-1_694_513_897)
public val Res.string.GENERAL_WEIGHT_PIECE_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_PIECE_FORMAT", "GENERAL_WEIGHT_PIECE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5056, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5124, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5260, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4788, 55),
      ))
    }

@delegate:ResourceContentHash(-2_078_788_999)
public val Res.string.GENERAL_WEIGHT_TBSP_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_TBSP_FORMAT", "GENERAL_WEIGHT_TBSP_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5112, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5180, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5316, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4844, 46),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("ABOUT_PRODUCT_SCREEN_TITLE_FORMAT", Res.string.ABOUT_PRODUCT_SCREEN_TITLE_FORMAT)
  map.put("BARCODE_SCANNER_INSTRUCTION", Res.string.BARCODE_SCANNER_INSTRUCTION)
  map.put("BARCODE_SCANNER_SCREEN_TITLE", Res.string.BARCODE_SCANNER_SCREEN_TITLE)
  map.put("BLAND_TODAY_GREETING_DEFAULT", Res.string.BLAND_TODAY_GREETING_DEFAULT)
  map.put("BLAND_TODAY_GREETING_USERNAME_FORMAT", Res.string.BLAND_TODAY_GREETING_USERNAME_FORMAT)
  map.put("BLAND_TODAY_MAIN_CONTROL_SECTION", Res.string.BLAND_TODAY_MAIN_CONTROL_SECTION)
  map.put("CALI_GREETINGS_1", Res.string.CALI_GREETINGS_1)
  map.put("CALI_GREETINGS_10", Res.string.CALI_GREETINGS_10)
  map.put("CALI_GREETINGS_11", Res.string.CALI_GREETINGS_11)
  map.put("CALI_GREETINGS_2", Res.string.CALI_GREETINGS_2)
  map.put("CALI_GREETINGS_3", Res.string.CALI_GREETINGS_3)
  map.put("CALI_GREETINGS_4", Res.string.CALI_GREETINGS_4)
  map.put("CALI_GREETINGS_5", Res.string.CALI_GREETINGS_5)
  map.put("CALI_GREETINGS_6", Res.string.CALI_GREETINGS_6)
  map.put("CALI_GREETINGS_7", Res.string.CALI_GREETINGS_7)
  map.put("CALI_GREETINGS_8", Res.string.CALI_GREETINGS_8)
  map.put("CALI_GREETINGS_9", Res.string.CALI_GREETINGS_9)
  map.put("CALI_GREETINGS_USERNAME_FORMAT", Res.string.CALI_GREETINGS_USERNAME_FORMAT)
  map.put("CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_LABEL", Res.string.CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_LABEL)
  map.put("CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_TEXT", Res.string.CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_TEXT)
  map.put("CALI_TODAY_OVERALL_DAILY_PROGRESS_HEADER", Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_HEADER)
  map.put("CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_LABEL", Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_LABEL)
  map.put("CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_TEXT", Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_TEXT)
  map.put("CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_LABEL", Res.string.CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_LABEL)
  map.put("CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_TEXT", Res.string.CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_TEXT)
  map.put("CONTENT_MEAL_PLAN_PERSONAL_LABEL", Res.string.CONTENT_MEAL_PLAN_PERSONAL_LABEL)
  map.put("CONTENT_SHOPPING_LIST_BUTTON", Res.string.CONTENT_SHOPPING_LIST_BUTTON)
  map.put("DAILY_TASKS_COMPLETED_TASKS_SECTION", Res.string.DAILY_TASKS_COMPLETED_TASKS_SECTION)
  map.put("DAILY_TASKS_SCREEN_TITLE", Res.string.DAILY_TASKS_SCREEN_TITLE)
  map.put("DAILY_TASKS_TO_DO_TASKS_SECTION", Res.string.DAILY_TASKS_TO_DO_TASKS_SECTION)
  map.put("ERROR_INVALID_CREDENTIALS", Res.string.ERROR_INVALID_CREDENTIALS)
  map.put("FOOD_HISTORY_SCREEN_TITLE", Res.string.FOOD_HISTORY_SCREEN_TITLE)
  map.put("GENERAL_AGE_EIGHTIES", Res.string.GENERAL_AGE_EIGHTIES)
  map.put("GENERAL_AGE_FIFTIES", Res.string.GENERAL_AGE_FIFTIES)
  map.put("GENERAL_AGE_FORTIES", Res.string.GENERAL_AGE_FORTIES)
  map.put("GENERAL_AGE_NINETIES", Res.string.GENERAL_AGE_NINETIES)
  map.put("GENERAL_AGE_SEVENTIES", Res.string.GENERAL_AGE_SEVENTIES)
  map.put("GENERAL_AGE_SIXTIES", Res.string.GENERAL_AGE_SIXTIES)
  map.put("GENERAL_AGE_THIRTIES", Res.string.GENERAL_AGE_THIRTIES)
  map.put("GENERAL_AGE_TWENTIES", Res.string.GENERAL_AGE_TWENTIES)
  map.put("GENERAL_AGE_YOUR_AGE", Res.string.GENERAL_AGE_YOUR_AGE)
  map.put("GENERAL_BMI", Res.string.GENERAL_BMI)
  map.put("GENERAL_CALORIES", Res.string.GENERAL_CALORIES)
  map.put("GENERAL_CALORIES_FORMAT", Res.string.GENERAL_CALORIES_FORMAT)
  map.put("GENERAL_CANCEL", Res.string.GENERAL_CANCEL)
  map.put("GENERAL_CARBO", Res.string.GENERAL_CARBO)
  map.put("GENERAL_CM_LABEL", Res.string.GENERAL_CM_LABEL)
  map.put("GENERAL_CONTINUE", Res.string.GENERAL_CONTINUE)
  map.put("GENERAL_DETAILS", Res.string.GENERAL_DETAILS)
  map.put("GENERAL_DONE", Res.string.GENERAL_DONE)
  map.put("GENERAL_ERROR_MAX_VALUE", Res.string.GENERAL_ERROR_MAX_VALUE)
  map.put("GENERAL_ERROR_MIN_VALUE", Res.string.GENERAL_ERROR_MIN_VALUE)
  map.put("GENERAL_FAT", Res.string.GENERAL_FAT)
  map.put("GENERAL_FIBRE", Res.string.GENERAL_FIBRE)
  map.put("GENERAL_FT_LABEL", Res.string.GENERAL_FT_LABEL)
  map.put("GENERAL_FT_UNIT", Res.string.GENERAL_FT_UNIT)
  map.put("GENERAL_GENDER_MEN", Res.string.GENERAL_GENDER_MEN)
  map.put("GENERAL_GENDER_WOMEN", Res.string.GENERAL_GENDER_WOMEN)
  map.put("GENERAL_GOOD_AFTERNOON", Res.string.GENERAL_GOOD_AFTERNOON)
  map.put("GENERAL_GOOD_EVENING", Res.string.GENERAL_GOOD_EVENING)
  map.put("GENERAL_GOOD_MORNING", Res.string.GENERAL_GOOD_MORNING)
  map.put("GENERAL_GOOD_NIGHT", Res.string.GENERAL_GOOD_NIGHT)
  map.put("GENERAL_IN_UNIT", Res.string.GENERAL_IN_UNIT)
  map.put("GENERAL_KG_LABEL", Res.string.GENERAL_KG_LABEL)
  map.put("GENERAL_LB_LABEL", Res.string.GENERAL_LB_LABEL)
  map.put("GENERAL_LITRES", Res.string.GENERAL_LITRES)
  map.put("GENERAL_NOW", Res.string.GENERAL_NOW)
  map.put("GENERAL_OK", Res.string.GENERAL_OK)
  map.put("GENERAL_OPEN", Res.string.GENERAL_OPEN)
  map.put("GENERAL_OZ", Res.string.GENERAL_OZ)
  map.put("GENERAL_PROTEIN", Res.string.GENERAL_PROTEIN)
  map.put("GENERAL_RELATIVE_DATE_DAYS_AGO_FORMAT", Res.string.GENERAL_RELATIVE_DATE_DAYS_AGO_FORMAT)
  map.put("GENERAL_RELATIVE_DATE_TODAY", Res.string.GENERAL_RELATIVE_DATE_TODAY)
  map.put("GENERAL_RELATIVE_DATE_YESTERDAY", Res.string.GENERAL_RELATIVE_DATE_YESTERDAY)
  map.put("GENERAL_SAVE", Res.string.GENERAL_SAVE)
  map.put("GENERAL_STEPS", Res.string.GENERAL_STEPS)
  map.put("GENERAL_SYMPTOM_BLOATING", Res.string.GENERAL_SYMPTOM_BLOATING)
  map.put("GENERAL_SYMPTOM_CONSTIPATION", Res.string.GENERAL_SYMPTOM_CONSTIPATION)
  map.put("GENERAL_SYMPTOM_EXCESS_GAS", Res.string.GENERAL_SYMPTOM_EXCESS_GAS)
  map.put("GENERAL_SYMPTOM_UNKNOWN", Res.string.GENERAL_SYMPTOM_UNKNOWN)
  map.put("GENERAL_TODAY", Res.string.GENERAL_TODAY)
  map.put("GENERAL_UNIT_CUP_LABEL", Res.string.GENERAL_UNIT_CUP_LABEL)
  map.put("GENERAL_UNIT_FL_OZ_LABEL", Res.string.GENERAL_UNIT_FL_OZ_LABEL)
  map.put("GENERAL_UNIT_GRAM_LABEL", Res.string.GENERAL_UNIT_GRAM_LABEL)
  map.put("GENERAL_UNIT_MEAL_LABEL", Res.string.GENERAL_UNIT_MEAL_LABEL)
  map.put("GENERAL_UNIT_ML_LABEL", Res.string.GENERAL_UNIT_ML_LABEL)
  map.put("GENERAL_UNIT_OZ_LABEL", Res.string.GENERAL_UNIT_OZ_LABEL)
  map.put("GENERAL_UNIT_PIECE_LABEL", Res.string.GENERAL_UNIT_PIECE_LABEL)
  map.put("GENERAL_UNIT_TBSP_LABEL", Res.string.GENERAL_UNIT_TBSP_LABEL)
  map.put("GENERAL_UNIT_TSP_LABEL", Res.string.GENERAL_UNIT_TSP_LABEL)
  map.put("GENERAL_WEIGHT_CUP_FORMAT", Res.string.GENERAL_WEIGHT_CUP_FORMAT)
  map.put("GENERAL_WEIGHT_FL_OZ_FORMAT", Res.string.GENERAL_WEIGHT_FL_OZ_FORMAT)
  map.put("GENERAL_WEIGHT_GRAM_FORMAT", Res.string.GENERAL_WEIGHT_GRAM_FORMAT)
  map.put("GENERAL_WEIGHT_KG_FORMAT", Res.string.GENERAL_WEIGHT_KG_FORMAT)
  map.put("GENERAL_WEIGHT_LB_FORMAT", Res.string.GENERAL_WEIGHT_LB_FORMAT)
  map.put("GENERAL_WEIGHT_MEAL_FORMAT", Res.string.GENERAL_WEIGHT_MEAL_FORMAT)
  map.put("GENERAL_WEIGHT_ML_FORMAT", Res.string.GENERAL_WEIGHT_ML_FORMAT)
  map.put("GENERAL_WEIGHT_OZ_FORMAT", Res.string.GENERAL_WEIGHT_OZ_FORMAT)
  map.put("GENERAL_WEIGHT_PIECE_FORMAT", Res.string.GENERAL_WEIGHT_PIECE_FORMAT)
  map.put("GENERAL_WEIGHT_TBSP_FORMAT", Res.string.GENERAL_WEIGHT_TBSP_FORMAT)
}
